<template>
  <div class="text-xs-center">
    <div :class="`preview-theme-${type}`">
      <div class="preview-wrap">
        <div class="preview-window">
          <img class="img-fluid" :src="`${item.params.preview[page]}`" />
        </div>
      </div>
    </div>

    <button
      v-if="type === 'sm' && item.params.preview[`${page}xl`]"
      @click="
        $emit('openDialog', {
          type: 'img',
          src: item.params.preview[`${page}xl`]
        })
      "
      class=""
    >
      <icon-fullscreen :color="$vuetify.theme.primary"></icon-fullscreen>
      <span class="subtitle-1 ml-2 line-height-1">
        Посмотреть экранную версию
      </span>
    </button>
  </div>
</template>
<script>
import IconFullscreen from "../icon/IconFullScreen.vue";

export default {
  name: "PollPreview",

  components: { IconFullscreen },

  props: {
    type: {
      type: String,
      default: "xs"
    },
    page: {
      type: String,
      default: "poll"
    },
    item: {
      type: Object,
      required: true
    }
  },

  data: () => ({}),

  mounted() {},

  computed: {},

  methods: {}
};
</script>
